import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/marketing/SmoothHashLink.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/client/app-dir/link.js");
